import styled from 'styled-components';

export const ErrorPage = styled.main`
  align-items: center;
  background: #f7f8fa;
  color: #1f242b;
  display: flex;
  min-height: 100vh;
  padding: 1.25rem;
`;

export const ErrorCard = styled.section`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(17, 24, 39, 0.08);
  margin: 0 auto;
  max-width: 680px;
  padding: clamp(1.5rem, 5vw, 2.5rem);

  p {
    color: #1d4ed8;
    font-size: 0.82rem;
    font-weight: 900;
    margin: 0 0 0.75rem;
    text-transform: uppercase;
  }

  h1 {
    color: #1f242b;
    font-size: clamp(2rem, 7vw, 3.4rem);
    line-height: 1.05;
    margin: 0 0 1rem;
  }

  span {
    color: #586271;
    display: block;
    line-height: 1.7;
    margin-bottom: 1.35rem;
  }
`;

export const ErrorActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;

  a {
    align-items: center;
    border: 2px solid #2563eb;
    border-radius: 8px;
    color: #111827;
    display: inline-flex;
    font-weight: 900;
    justify-content: center;
    min-height: 48px;
    padding: 0.85rem 1.2rem;
    text-decoration: none;
  }

  a:first-child {
    background: #2563eb;
    color: #ffffff;
  }

  @media (max-width: 520px) {
    a {
      width: 100%;
    }
  }
`;
